<div #activityLog class=" d-flex h-100 e-box  flex-wrap flex-lg-nowrap">
  <!-- <div class="edit-icons cursor-pointer" mat-dialog-close>
    <i class="material-icons">close</i>
  </div> -->

  <div class="e-left mt-2 mt-lg-0">
    <div class="e-cont">
      <div class="e-img mt-2 mt-sm-3 mt-md-4" *ngIf="!empData" [appBackgroundImg]="empData?.profile_picture"></div>
      <div class="e-img mt-2 mt-sm-3 mt-md-4" *ngIf="empData" [appBackgroundImg]="empData.profile_picture"></div>
      <div class="s-header-title mb-0 mt-2 mt-sm-3 text-center">{{empData?.first_name}} {{ empData?.last_name }}</div>
      <div class="text-center mt-1 e-t">{{empData?.email }}</div>

      <div class="d-flex align-items-center justify-content-center st-txt" (click)="toggleFavourite()">
        <i class="material-icons pe-2 cursor-pointer"
          [ngClass]="{ 'text-danger': isFavourite, 'text-secondary': !isFavourite }">
          {{ isFavourite ? 'favorite' : 'favorite_border' }}
        </i>
        Add to Favourites
      </div>

      <div class="custom-modal-backdrop " *ngIf="showModal">
        <div class="custom-modal">
          <h5>Edit Employee Type</h5>

          <div *ngIf="empData?.salaried == 1">
            Are you sure you want to switch employee from Salaried to Contract base
          </div>
          <div *ngIf="empData?.salaried == 0">
            Are you sure you want to switch employee from Contract base to Salaried
          </div>

          <div class="modal-footer">
            <button class="btn btn-outline-primary" (click)="closeModal()">Cancel</button>
            <button class="btn btn-primary" (click)="saveChanges(empData?.salaried)">Submit</button>
          </div>
        </div>
      </div>

      <div class="sb-container d-flex flex-column gap-3">
        <div class="i-c d-flex gap-1  align-items-center cursor-pointer flex-wrap">
          <div class="i-l d-flex align-items-center">
            <img src="assets/images/icons/user_nd.png" class="img-fluid  mb-n-3" alt=""> Employ Type:
          </div>
          <div class="i-l text-black d-flex gap-2" (click)="openTypeEditModel(empData?.salaried)">
            {{ empData?.salaried == 1 ? 'Salaried' : 'Contracted' }}
            <img src="assets/images/icons/edit-icon.svg" class="img-fluid me-2" alt="">
          </div>
        </div>

        <div class="i-c d-flex gap-1 align-items-center  flex-wrap">
          <div class="i-l  d-flex align-items-center">
            <img src="assets/images/icons/calender_nd.png" class="img-fluid mb-n-3" alt="">Start Date:
          </div>
          <div class="i-l text-black">{{empData?.create_time}}</div>
        </div>
        <div class="i-c gap-1 d-flex align-items-center flex-wrap">
          <div class="i-l  d-flex align-items-center">
            <img src="assets/images/icons/phone_number.png" class="img-fluid  mb-n-3">Phone No:
          </div>
          <div class="i-l text-black">{{empData?.p_no}}</div>
        </div>
      </div>
    </div>

    <div class="emp-sidemenu-cont overflow-auto d-flex flex-column">
      <div class="b-1-5"></div>
      <div class="e-si  cursor-pointer d-flex align-items-center" *ngFor="let item of arr" (click)="onMenuBox(item)"
        [ngClass]="{'e-sel': selectedSideMenu === item.id }">
        <i class="material-icons me-1" style="color:black;font-size: 18px;margin-top: -3px;">{{item.icon}}</i>
        <div class="d-flex flex-column">
          <div>{{item.name}}</div>
          <!-- <div class="new-t">a{{selectedItemId}}a</div>
          <div class="new-t">b{{item.id}}b</div> -->
        </div>
      </div>
      <div class="e-si  cursor-pointer d-flex align-items-center" *ngFor="let item of sideMenu"
        (click)="onSideMenuChange(item)" [ngClass]="{'e-sel':item.id==selectedSideMenu}">
        <i class="material-icons me-1" style="color:black;font-size: 18px;margin-top: -3px;">{{item.icon}}</i>
        <div>{{item.name}}</div>
      </div>
    </div>

  </div>

  <div id="e-right" class="e-right position-relative flex-grow-1 d-flex flex-column">
    <div class="item-header">
      <h6 class="text-center">{{title}}</h6>
      <div class="edit-icons" mat-dialog-close>
        <i class="material-icons">close</i>
      </div>
    </div>
    <!-- <div class="">
      <div class="n-b-cont d-flex flex-wrap gap-3 ">
        <div class="new-b" [ngClass]="{ 'selected': selectedItemId === item.id }" *ngFor="let item of arr" (click)="onMenuBox(item.id)">
          <div class="d-flex align-items-center">
            <div class="new-t">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="d-flex flex-column  flex-grow-1 overflow-auto" *ngIf="!isSpinnerLoading"
      [ngClass]="selectedSideMenu=='2' ? 'flex-grow-1':''">

      <div *ngIf="selectedSideMenu == '0'" class="d-flex flex-column flex-grow-1 mt-4">

        <!-- <mat-form-field class="c-d-r" appearance="fill">
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" (click)="picker.open()" />
            <input matEndDate placeholder="End date" (click)="picker.open()" />
          </mat-date-range-input>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field> -->

        <mat-form-field class="c-d-r" appearance="fill">
          <mat-date-range-input [rangePicker]="picker" [formGroup]="dateForm">
            <input matStartDate placeholder="Start date" formControlName="start" (click)="picker.open()" />
            <input matEndDate placeholder="End date" formControlName="end" (click)="picker.open()" />
          </mat-date-range-input>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>

        <div class="b-1-5 mt-24 mb-24"></div>

        <div class="d-flex flex-column">
          <div class="activity-log">


            <div class="d-flex flex-column mb-20 pse-25">
              <mat-expansion-panel *ngFor="let item of activityArr; let i = index" class="height-55"
                (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header class="me-2">
                  <mat-panel-title>
                    <div class="pro-pic me-2">
                      <div class="profile-img me-2" [appBackgroundImg]="item.actor_img"></div>
                    </div>
                    <div class="log-content">
                      <div class="d-flex gap-2 flex-wrap line-normal">
                        {{item.actor_name}}
                        <div class=" a-pri">{{item.affect_type}}</div>
                      </div>

                    </div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <!-- <i class="material-icons cursor-pointer" (click)="onEdit(dataDetails,'normal')">edit</i> -->
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="inner-container d-flex flex-column gap-2">
                  <div class="small-text">{{item.j_n}}</div>
                  <div class="small-text">{{item.j_c}}({{item.j_sc}})</div>
                  <div class="small-text">{{item.c_at}}</div>
                  <div class="small-text">{{item.add}}</div>
                </div>

              </mat-expansion-panel>

              <!-- <div class="log-entry" *ngFor="let item of activityArr">
                <div class="pro-pic me-2">
                  <div class="profile-img me-2" [appBackgroundImg]="item.actor_img"></div>
                </div>
                <div class="log-content">
                  <div class="d-flex flex-wrap line-normal">
                    {{item.actor_name}}
                    <div class="ms-2 a-pri">{{item.affect_type}}</div>
                  </div>
                  <div class="small-text">{{item.c_at}}</div>
                </div>
              </div> -->

              <!-- <div class="log-entry">
                <div class="pro-pic me-2">
 
                </div>
                <div class="log-content">
                  <div class="d-flex flex-wrap line-normal">
                    Hiren Patel exported
                    <a href="#">payroll</a>
                  </div>
                  <div class="small-text ">2024-12-24</div>
                </div>
              </div> -->
            </div>

          </div>
        </div>

      </div>


      <div *ngIf="selectedSideMenu == 'approved_roles'">
        <app-job-preference-detail [employeeId]="employeeId"></app-job-preference-detail>
      </div>

      <div *ngIf="selectedSideMenu=='1'">
        <div class="box-container d-flex flex-wrap mt-4">
          <div class="box-i" *ngFor="let item of boxArr">
            <div class="d-flex align-items-center">
              <div class="box-img me-2">
                <img [src]="item.cont_img" class="img-fluid " alt="">
              </div>
              <div class="count text-bold" [ngClass]="{
                      'total-course': item.content_type === 'courses',
                      'course-started': item.content_type === 'course started',
                      'exam-attendend': item.content_type === 'exam attended',
                      'total-passed': item.content_type === 'course passed',   
                      'total-failed':item.content_type === 'course failed',
                      'total-informational': item.content_type === 'informational course',                  
                      'with-exam': item.content_type === 'exam course'}">{{item.value}}</div>
            </div>
            <div class="mt-2 box-text">{{item.text}}</div>
          </div>
        </div>
        <div class="input-container d-flex flex-column flex-wrap justify-content-between mt-3 mt-xl-4 mb-4">
          <div class="d-flex justify-content-between gap-3 flex-wrap">
            <div class="search-cont gap-sm-3 mb-3 w-60">
              <div class="s-in form-input me-0" style="position:relative">
                <mat-icon class="input-icon">search</mat-icon>
                <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="objData.training.sh"
                  (input)="onSearch($event,'training')" (keyup.enter)="onGo('training')" />
              </div>
            </div>
            <div class="d-flex  mt-3 mt-lg-0   ms-md-3 ms-lg-0" *ngIf="dialogData.type=='company'">
              <button type="button" class="btn btn-icon btn-outline-primary d-flex align-items-center"
                (click)="onAssignCourse()">
                <img src="assets/images/icons/csv.png" alt="" class="img-fluid me-2">Assign Course </button>
            </div>
          </div>
          <app-filter *ngIf="isFilterShow" (childEvent)="callApi($event)" [fieldCol]="filterArr"></app-filter>
          <div class="w-100" style="overflow-x: auto;" *ngIf="dataSource.data.length!=0">
            <table class="mt-2 mt-sm-3 mt-md-4" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              <ng-container matColumnDef="course_info">
                <th class="min-w-280" mat-header-cell *matHeaderCellDef>Courses</th>
                <td mat-cell *matCellDef="let element" class="td-1">
                  <div class="d-flex  align-items-center ">
                    <div class="course-img me-2" [appBackgroundImg]="element.img" iType="course"> </div>
                    <div class="">
                      <div>{{element.tit}} </div>
                      <div class="steel-blue">{{element.dep}}</div>
                    </div>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="completed_practical">
                <th mat-header-cell *matHeaderCellDef class="text-center min-t-width"> Completed Practical ?
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <mat-checkbox (change)="changeCoursePractical($event, element)" [disabled]="element.m_c_g1 == 0"
                    [ngClass]="{'disabled-btn': element.m_c_g1 == 0}"
                    [checked]="element.is_pr==1 && element.m_c_g1 != 0" [color]="'primary'">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="certificate_access">
                <th mat-header-cell *matHeaderCellDef class="text-center min-w-145"> Give Certificate Access to
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                  <mat-checkbox [checked]="element.m_c_g==1 && element.m_c_g1 != 0 && element.is_pr!=0"
                    [disabled]="element.m_c_g1 == 0 || element.is_pr==0" [color]="'primary'"
                    [ngClass]="{'disabled-btn': element.m_c_g1 == 0 && element.is_pr==0}"
                    (change)="changeCertifcateAccess($event, element)">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="training_date">
                <th mat-header-cell *matHeaderCellDef> Training Date</th>
                <td mat-cell *matCellDef="let element"> {{element.tr_dt | dates}} </td>
              </ng-container>
              <ng-container matColumnDef="deadline_date">
                <th mat-header-cell *matHeaderCellDef> Deadline Date</th>
                <td mat-cell *matCellDef="let element"> {{element.de_dt | dates }} </td>
              </ng-container>
              <ng-container matColumnDef="course_type">
                <th mat-header-cell *matHeaderCellDef> Course Type</th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-bold st-box  d-flex ">
                    <span class="blue-badge badge-c d-box" *ngIf="element.is_info== 0">Exam</span>
                    <span class="active badge-c d-box" *ngIf="element.is_info == 1">Informational</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="course_status">
                <th mat-header-cell *matHeaderCellDef>Course Status</th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-bold st-box  d-flex ">
                    <span class="pending badge-c d-box" *ngIf="element.is_st && !(element.per >= 100)">Active</span>
                    <span class="un-attend badge-c d-box" *ngIf="!element.is_st">Unattended</span>
                    <span class=" active  badge-c d-box" *ngIf="element.is_st && element.per >= 100">Completed</span>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="course_progres">
                <th mat-header-cell *matHeaderCellDef>Course Progress</th>
                <td mat-cell *matCellDef="let element">
                  <mat-progress-bar mode="determinate" class="progress-m progress-round green-progress progress-shadow"
                    [value]="element.per"></mat-progress-bar>
                </td>
              </ng-container>
              <ng-container matColumnDef="exam_status">
                <th mat-header-cell *matHeaderCellDef>Exam Status</th>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="element.is_info == 1">-</div>
                  <div class="text-bold st-box  d-flex " *ngIf="element.is_info== 0">
                    <span class="un-attend badge-c d-box" *ngIf="element.is_att==0">Unattended</span>
                    <span class="un-attend badge-c d-box" *ngIf="element.is_p==0 && element.is_att==1">Failed</span>
                    <span class=" active  badge-c d-box" *ngIf="element.is_p==1 && element.is_att==1">Passed</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex ">
                    <div class="d-flex" *ngIf=" element.m_c_g1 == 0 || (element.m_c_g1 == 1 && element.is_pr == 1)">
                      <div class="action-icon  me-2 " (click)="onViewExamSheet(element)" *ngIf="element.is_att"
                        matTooltip="View Exam Sheet">
                        <img src="assets/images/icons/view_icon.png" class="img-fluid" alt="">
                      </div>
                      <!-- add is_p here is certificate exist -->
                      <div class="action-icon  me-2 " *ngIf="(element.c_img && (element.is_p==1)) "
                        matTooltip="Certificate Download" (click)="onCertificateDownload(element)">
                        <img src="assets/images/icons/certificate_ic.svg" class="img-fluid">
                      </div>
                      <div class="action-icon   me-2" (click)="onMoreInfo(element)" matTooltip="More Course Info"
                        *ngIf="element.is_att">
                        <img src="assets/images/icons/more_info.svg" class="img-fluid">
                      </div>
                    </div>
                    <div class="action-icon   me-2" (click)="onDeleteItem(element)" matTooltip="Delet Course">
                      <img src="assets/images/icons/delete-icon.svg">
                    </div>
                  </div>

                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <div class="mat-table__message" *ngIf="dataSource.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
          <div class="d-flex justify-content-between align-items-center flex-wrap" *ngIf="dataSource.data.length!=0">
            <div class="me-3 text-grey d-flex align-items-center">
              {{"COMMON.SIP" | translate}}
              <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                [(ngModel)]="config.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">
                  {{ item }}
                </option>
              </select>
            </div>
            <div>
              <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedSideMenu=='2'" class="h-100">
        <app-notes [employeeId]="dialogData.employee_id" class="flex-grow-1"></app-notes>
      </div>
      <div *ngIf="selectedSideMenu=='31'">
        <div class="mt-3">
          <app-bank-detail [employeeId]="dialogData.employee_id"></app-bank-detail>
        </div>
      </div>
      <div *ngIf="selectedSideMenu=='3'">
        <app-payroll [employeeId]="dialogData.employee_id"></app-payroll>
      </div>
      <div *ngIf="selectedSideMenu=='4'" class="mt-4">
        <app-hr-docs [employeeId]="dialogData.employee_id"></app-hr-docs>
      </div>

      <div *ngIf="selectedSideMenu=='8'">
        <!-- This is for holiday data -->
      </div>

      <div *ngIf="selectedSideMenu=='7'">
        <div class="">
          <app-experience-detail [employeeId]="dialogData.employee_id"></app-experience-detail>
        </div>
      </div>
      <div class="d-flex flex-column" style="height: 100%" *ngIf="selectedSideMenu=='current_shift'">
        <div class="search-cont gap-sm-3 mt-4">
          <div class="s-in form-input me-0" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="objData.current_shift.sh"
              (input)="onSearch($event,'current_shift')" (keyup.enter)="onGo('current_shift')" />
          </div>
        </div>
        <div class="table-container flex-grow-1 mt-3">
          <table class="" mat-table [dataSource]="dataSourceCurrent" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="company_name">
              <th mat-header-cell *matHeaderCellDef>Company Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="user-profile name table-row-e">
                  <div class="profile-img me-2" [appBackgroundImg]="element.company_logo"> </div>
                  <div class="">
                    <div class="main-head">{{element.company_name}} </div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="company_add">
              <th mat-header-cell *matHeaderCellDef> Company Address</th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2">
                  {{element.add }}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.TITLE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_n }} </td>
            </ng-container>
            <ng-container matColumnDef="department">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-semibold">{{element.j_c }}</div>
                <div>{{element.j_sc }}</div>
              </td>
            </ng-container>
            <!-- <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-semibold">{{element.j_c }}</div>
                <div>{{element.j_sc }}</div>
              </td>
            </ng-container> -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> Date</th>
              <td mat-cell *matCellDef="let element"> {{element.st_dt | dates}} - {{element.ed_dt | dates}} </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef> Time</th>
              <td mat-cell *matCellDef="let element"> {{element.st_ti}} - {{element.ed_ti}} </td>
            </ng-container>
            <!-- <ng-container matColumnDef="clock_in">
              <th mat-header-cell *matHeaderCellDef>Clock In/Out</th>
              <td mat-cell *matCellDef="let element"> -- </td>
            </ng-container> -->
            <ng-container matColumnDef="wages">
              <th mat-header-cell *matHeaderCellDef> Wages(€)</th>
              <td mat-cell *matCellDef="let element"> {{element.wages}}/hr</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColCurrent"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColCurrent;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSourceCurrent.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
        <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceCurrent.data.length!=0"></div>
      </div>


      <div class="d-flex flex-column" style="height: 100%" *ngIf="selectedSideMenu=='upcoming_shift'">
        <div class="search-cont gap-sm-3 mt-4">
          <div class="s-in form-input me-0" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="{{'Search...'}}" class="form-control"
              [(ngModel)]="objData.upcoming_shift.sh" (input)="onSearch($event,'upcoming_shift')"
              (keyup.enter)="onGo('upcoming_shift')" />
          </div>
        </div>
        <div class="table-container flex-grow-1 mt-3">
          <table class="" mat-table [dataSource]="dataSourceUpc" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="company_name">
              <th mat-header-cell *matHeaderCellDef class="c-name"> Company Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="user-profile name table-row-e">
                  <div class="profile-img me-2" [appBackgroundImg]="element.company_logo"> </div>
                  <div class="">
                    <div class="main-head">{{element.company_name}} </div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="company_add">
              <th mat-header-cell *matHeaderCellDef> Company Address</th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2">
                  {{element.add }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.TITLE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_n }} </td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-semibold">{{element.j_c }}</div>
                <div>{{element.j_sc }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> Date</th>
              <td mat-cell *matCellDef="let element"> {{element.st_dt | dates}} - {{element.ed_dt | dates}} </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef> Time</th>
              <td mat-cell *matCellDef="let element"> {{element.st_ti}} - {{element.ed_ti}} </td>
            </ng-container>
            <ng-container matColumnDef="wages">
              <th mat-header-cell *matHeaderCellDef> Wages(€)</th>
              <td mat-cell *matCellDef="let element"> {{element.wages}}/hr </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColUpc"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColUpc;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSourceUpc.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
        <div [ngTemplateOutlet]="pagination" *ngIf="dataSourceUpc.data.length!=0"></div>
      </div>

      <div class="d-flex flex-column" style="height: 100%" *ngIf="selectedSideMenu=='past_shift'">
        <div class="search-cont gap-sm-3 mt-4">
          <div class="s-in form-input me-0" style="position:relative">
            <mat-icon class="input-icon">search</mat-icon>
            <input type="text" placeholder="{{'Search...'}}" class="form-control" [(ngModel)]="objData.past_shift.sh"
              (input)="onSearch($event,'past_shift')" (keyup.enter)="onGo('past_shift')" />
          </div>
        </div>
        <div class="table-container flex-grow-1 mt-3">
          <table class="" mat-table [dataSource]="dataSourcePast" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="company_name">
              <th mat-header-cell *matHeaderCellDef> Company Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="user-profile name table-row-e">
                  <div class="profile-img me-2" [appBackgroundImg]="element.company_logo"> </div>
                  <div class="">
                    <div class="main-head">{{element.company_name}} </div>
                    <div class="sub-head">{{element.email}}</div>
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="company_add">
              <th mat-header-cell *matHeaderCellDef> Company Address</th>
              <td mat-cell *matCellDef="let element">
                <div class="hide-lines-2">
                  {{element.add }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.TITLE"|translate}}</th>
              <td mat-cell *matCellDef="let element"> {{element.j_n }} </td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef> {{"COMMON.CATEGORY"|translate}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="text-semibold">{{element.j_c }}</div>
                <div>{{element.j_sc }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef>Date</th>
              <td mat-cell *matCellDef="let element"> {{element.st_dt | dates}} - {{element.ed_dt | dates}} </td>
            </ng-container>
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef>Time</th>
              <td mat-cell *matCellDef="let element"> {{element.st_ti}} - {{element.ed_ti}} </td>
            </ng-container>
            <!-- <ng-container matColumnDef="clock_in">
              <th mat-header-cell *matHeaderCellDef>Clock In/Out</th>
              <td mat-cell *matCellDef="let element"> -- </td>
            </ng-container> -->
            <ng-container matColumnDef="wages">
              <th mat-header-cell *matHeaderCellDef> Wages(€)</th>
              <td mat-cell *matCellDef="let element"> {{element.wages}}/hr</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColPast"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColPast;"></tr>
          </table>
          <div class="mat-table__message" *ngIf="dataSourcePast.data.length==0">
            <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
        <div [ngTemplateOutlet]="pagination" *ngIf="dataSourcePast.data.length!=0"></div>
      </div>
    </div>

    <div *ngIf="isSpinnerLoading" class="custom-loader"></div>

  </div>

</div>
<ng-template #pagination>
  <div class="pagination-cont">
    <div class="show-item"> {{"COMMON.SIP" | translate}}
      <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)" [(ngModel)]="config.itemsPerPage">
        <option [value]="item" *ngFor="let item of pageSizeOptions"> {{ item }}</option>
      </select>
    </div>
    <div class="page-c">
      <ngb-pagination [collectionSize]="countPagination" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
        [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
    </div>
  </div>
</ng-template>